export interface IApiClubSearchCategory {
  Value?: number;
  Text?: string;
  IsMatch?: boolean;
}

export interface IApiClubSearchLocation {
  City?: string;
  State?: string;
  StateAbbr?: string;
  Country?: string;
}

export interface IApiClubSearchMainPhoto {
  PhotoID?: number;
  ThumbUrl?: string;
  FullUrl?: string;
  Width?: number;
  Height?: number;
  IsMain?: boolean;
}

export interface IApiClubSearch {
  CommentCount?: number;
  ClubID?: number;
  ClubName?: string;
  Location?: IApiClubSearchLocation;
  Categories?: IApiClubSearchCategory[];
  Rating?: number;
  IsFeatured?: boolean;
  IsSponsored?: boolean;
  MainPhoto?: IApiClubSearchMainPhoto;
}

export default class clubSearch {
  reviewsCount: number;
  clubId: number;
  clubName: string;
  location: any;
  categories: any[];
  rating: number;
  mainPhoto: any;
  isFeatured: boolean;
  isSponsored: boolean;

  constructor() {
    this.reviewsCount = 0;
    this.clubId = -1;
    this.clubName = '';
    this.location = {};
    this.categories = [];
    this.rating = 0;
    this.mainPhoto = {};
    this.isFeatured = false;
    this.isSponsored = false;
  }

  static mappingObjectCategory(category: IApiClubSearchCategory) {
    const obj = {
      value: null as number | null,
      text: null as string | null,
      isMatch: false,
    };
    obj.value = category.Value ? category.Value : null;
    obj.text = category.Text ? category.Text : null;
    obj.isMatch = category.IsMatch ? category.IsMatch : false;
    return obj;
  }

  static mappingObjectCategories(categories: IApiClubSearchCategory[]) {
    const categoriesResult: any[] = [];
    if (categories) {
      categories.forEach(c => {
        categoriesResult.push(clubSearch.mappingObjectCategory(c));
      });
    }
    return categoriesResult;
  }

  static mappingObjectMainPhoto(user: IApiClubSearchMainPhoto) {
    const obj = {
      photoId: null as number | null,
      thumbUrl: '' as string | null,
      fullUrl: '' as string | null,
      width: null as number | null,
      height: null as number | null,
      isMain: false,
    };
    obj.photoId = user && user.PhotoID ? user.PhotoID : 0;
    obj.thumbUrl = user && user.ThumbUrl ? user.ThumbUrl : null;
    obj.fullUrl = user && user.FullUrl ? user.FullUrl : null;
    obj.width = user && user.Width ? user.Width : null;
    obj.height = user && user.Height ? user.Height : null;
    obj.isMain = user && user.IsMain ? user.IsMain : false;
    return obj;
  }

  static mappingObjectLocation(object: IApiClubSearchLocation) {
    const newObject = {
      city: '',
      state: '',
      stateAbbr: '',
      country: '',
    };
    newObject.city = object && object.City ? object.City : '';
    newObject.state = object && object.State ? object.State : '';
    newObject.stateAbbr = object && object.StateAbbr ? object.StateAbbr : '';
    newObject.country = object && object.Country ? object.Country : '';
    return newObject;
  }

  static mappingObject(user: IApiClubSearch): clubSearch {
    const profile = new clubSearch();
    if (user) {
      profile.reviewsCount = user.CommentCount || 0;
      profile.clubId = user.ClubID || 0;
      profile.clubName = user.ClubName || '';
      profile.location = user.Location ? clubSearch.mappingObjectLocation(user.Location) : {};
      profile.categories = user.Categories ? clubSearch.mappingObjectCategories(user.Categories) : [];
      profile.rating = user.Rating || 0;
      profile.isFeatured = user.IsFeatured || false;
      profile.isSponsored = user.IsSponsored || false;
      profile.mainPhoto = user.MainPhoto ? clubSearch.mappingObjectMainPhoto(user.MainPhoto) : {};
    }
    return profile;
  }

  static mappingObjects(_users: IApiClubSearch[]): clubSearch[] {
    const users: clubSearch[] = [];
    _users.forEach(_user => {
      const user = clubSearch.mappingObject(_user);
      users.push(user);
    });
    return users;
  }
}
